export default __webpack_public_path__ + "img/bYlxRfyM.1bdca2eb.svg";